// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bHIb","rootMobile":"styles_rootMobile__rk0CA"};